export default "__VITE_ASSET__$NUTp9hu__"